module.exports = __webpack_public_path__ + "static/landscape_image-58eaf0c47ac2ec961ec98a6c64ad37e8.png";